import {Pipe, PipeTransform} from "@angular/core";
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'checklistRangeUnit'
})
export class ChecklistRangeUnitPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) {}

    transform(value: number, unit: String): string {
        value = value || 0;

        let formatted = value.toString();
        switch (unit) {
            case 'none':
                break;
            case 'ft':
                formatted += value === 1 ? ' foot' : ' feet';
                break;
            case 'in':
                formatted += value === 1 ? ' inch' : ' inches';
                break;
            case 'cm':
                formatted += 'cm';
                break;
            case 'mm':
                formatted += 'mm';
                break;
            case '32&mm':
            default:
                formatted += '/32in (' + this.decimalPipe.transform(value * .8, "1.2-2") + 'mm)';
        }

        return formatted;
    } // transform()

} // ChecklistRangeUnitPipe
